import { connect } from 'react-redux'
import { DrawerComponent } from './DrawerComponent'

const mapStateToProps = (state: any): any => {
	return {
	}
}

const mapDispatchToProps : any = {
}

export const DrawerContainer = connect(mapStateToProps, mapDispatchToProps)(DrawerComponent)
